import * as React from 'react';
import Autocomplete, { AutocompleteProps } from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Box from '@mui/material/Box';

export interface AutoProps extends AutocompleteProps<string | number, boolean | undefined, boolean | undefined,
     boolean | undefined>{
        options:any[];
        label?: string | React.ReactNode;
        tooltip?:React.ReactElement;
        required?: boolean;
    }

export default function FdAutoComplete({options, label, tooltip, required, ...rest}: AutoProps) {
  return (
    <FormControl fullWidth>
    <FormLabel sx={{fontSize:'12.5px'}}>
      {label}
      {tooltip}
      {required ? (
        <Box component="span" sx={{ color: "error.main" }}>
          *
        </Box>
      ) : (
        ""
      )}
    </FormLabel>
    <Autocomplete
      options={options}
      {...rest}
    //   renderInput={(params) => <TextField {...params} label={label} />}
    />
  </FormControl>
    
  );
}


// import { Autocomplete, AutocompleteProps } from "@mui/material";

// export interface FdAutoCompleteProps<T> {
//   autocompleteProps: AutocompleteProps<
//     T,
//     boolean | undefined,
//     boolean | undefined,
//     boolean | undefined
//   >;
//   label?: string;
//   loading?: boolean;
//   id?:any;
// }

// export const FdAutoComplete = <T extends unknown>(
//   props: FdAutoCompleteProps<T>
// ) => {
//   const { autocompleteProps } = props;

//   return <Autocomplete {...autocompleteProps} />;
// };